import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COOKIE_CONSENT_EVENT, getCookieConsent } from './CookieConsentBanner';

const WHATSAPP_NUMBER = '33753446689';
const HIDDEN_PREFIXES = ['/admin', '/dashboard', '/teacher', '/login', '/register'];

export function WhatsAppButton() {
  const { t } = useTranslation();
  const location = useLocation();
  const [cookieBannerVisible, setCookieBannerVisible] = useState(false);

  useEffect(() => {
    setCookieBannerVisible(!getCookieConsent());
    const handler = () => setCookieBannerVisible(!getCookieConsent());
    window.addEventListener(COOKIE_CONSENT_EVENT, handler);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, handler);
  }, []);

  if (HIDDEN_PREFIXES.some((prefix) => location.pathname.startsWith(prefix))) {
    return null;
  }

  const message = t('whatsappButton.message');
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsappButton.ariaLabel')}
      className={`fixed right-5 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-all hover:scale-105 ${
        cookieBannerVisible ? 'bottom-24 sm:bottom-20' : 'bottom-5'
      }`}
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" aria-hidden="true">
        <path d="M16.004 2.667c-7.364 0-13.333 5.97-13.333 13.333 0 2.351.617 4.646 1.789 6.665L2.667 29.333l6.83-1.79a13.27 13.27 0 0 0 6.507 1.706h.006c7.363 0 13.333-5.97 13.333-13.333 0-3.56-1.387-6.907-3.905-9.425a13.243 13.243 0 0 0-9.428-3.907Zm0 24.4h-.005a11.06 11.06 0 0 1-5.636-1.543l-.404-.24-4.053 1.063 1.082-3.951-.263-.406a11.05 11.05 0 0 1-1.694-5.887c0-6.106 4.968-11.07 11.077-11.07 2.958 0 5.738 1.153 7.83 3.246a11.005 11.005 0 0 1 3.242 7.83c-.003 6.106-4.97 11.07-11.076 11.07Zm6.073-8.29c-.333-.167-1.966-.97-2.27-1.08-.305-.111-.527-.167-.75.166-.222.334-.86 1.08-1.054 1.303-.194.223-.389.25-.722.084-.334-.167-1.409-.519-2.684-1.655-.992-.885-1.663-1.978-1.858-2.312-.194-.334-.021-.514.146-.68.15-.15.334-.39.5-.585.167-.195.223-.334.334-.556.111-.223.056-.417-.028-.584-.083-.167-.75-1.806-1.028-2.474-.271-.65-.546-.562-.75-.572-.194-.01-.417-.012-.639-.012a1.23 1.23 0 0 0-.888.417c-.305.334-1.165 1.14-1.165 2.778s1.193 3.222 1.36 3.445c.166.222 2.35 3.59 5.695 5.034.796.343 1.417.548 1.901.702.799.254 1.526.218 2.101.132.641-.096 1.966-.804 2.244-1.581.278-.777.278-1.443.194-1.581-.083-.14-.305-.223-.639-.39Z" />
      </svg>
    </a>
  );
}
